import React from 'react';
import useApplyHardwareFirstInAppPromo from '../hooks/useApplyHardwareFirstInAppPromo';
import { isInAppShop } from '../lib/inAppShop';

/** renders nothing; runs the promo hook only while the visitor is in-app */
function Applier(): null {
  useApplyHardwareFirstInAppPromo();
  return null;
}

/**
 * Mount gate for the in-app hardware-first promo auto-apply. The gate lives in a component so the
 * hook, and the banner impression `usePromotion` reports, only mount for in-app sessions.
 */
export default function HardwareFirstInAppPromoAutoApply(): JSX.Element | null {
  return isInAppShop() ? <Applier /> : null;
}
